import { render, staticRenderFns } from "./Brain.vue?vue&type=template&id=90446814&"
import script from "./Brain.vue?vue&type=script&lang=js&"
export * from "./Brain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90446814')) {
      api.createRecord('90446814', component.options)
    } else {
      api.reload('90446814', component.options)
    }
    module.hot.accept("./Brain.vue?vue&type=template&id=90446814&", function () {
      api.rerender('90446814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brain.vue"
export default component.exports